module.exports = __webpack_public_path__ + "static/media/plan3.e6c68b71.jpeg";